module.exports = __webpack_public_path__ + "media/application/images/svgs/social_twitter-06a1152b8171a01f5fd50ecfe76d5eca.svg";